import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  LinkOutlined,
  TagsOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Card,
  Checkbox,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
  Upload,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import customerApi from '../../api/customer.api'
import pushApi from '../../api/push.api'
import AppPushTemplatesModal from '../../components/appPush/AppPushTemplatesModal'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/product.module.scss'
import { CustomerAPIResponseMapper } from '../../utils/CustomerListMapper'
import { salusS3 } from '../../api/s3.api'

// UserSegment enum 수정
const UserSegment = {
  All: '전체',
  AD: '광고 수신 동의',
  MALE: '남성',
  FEMALE: '여성',
  BIRTHDAY_TODAY: '오늘 생일',
  BIRTHDAY_THIS_MONTH: '이번 달 생일',
  AGE_10S: '10대',
  AGE_20S: '20대',
  AGE_30S: '30대',
  AGE_40S: '40대',
  AGE_50S: '50대',
  AGE_60S: '60대 이상',
  IS_LIBRE_CONNECTED: '현재 리브레 연동 중',
  IS_LIBRE_NOT_CONNECTED: '현재 리브레 연동 안 함',
  HAS_LIBRE_CONNECTED: '리브레 연동 이력 있음',
  SIGNUP_ROUTE_INSTA: '인스타로 가입',
  SIGNUP_ROUTE_YOUTUBE: '유튜브로 가입',
  SELECTED_USERS: '개별 선택',
}

// 푸시 타입 옵션
const pushTypeOptions = [
  // { label: '알림', value: 1 },
  // { label: '커뮤니티', value: 2 },
  // { label: '공지사항', value: 3 },
  // { label: '광고및이벤트', value: 4 },
  // { label: '혈당블로킹', value: 5 },
  // { label: '슈팜', value: 6 },
  // { label: '출석체크', value: 7 },
  // { label: '오늘달', value: 8 },
  // { label: '하루 혈당 밸런스', value: 9 },
  // { label: '혈당 스캔', value: 10 },
  { label: '광고 및 이벤트', value: 11 },
]

const AppPushSendPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [customers, setCustomers] = useState([])
  const [totalCustomerCount, setTotalCustomerCount] = useState({
    all: 0, // 전체 회원 수
    currentPageCount: 0, // 현재 페이지 회원 수
  })
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [searchOptions, setSearchOptions] = useState({
    searchType: 'total',
    searchValue: null,
    dateType: 'total',
    startDate: null,
    endDate: null,
  })
  const [totalSize, setTotalSize] = useState(0)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false)
  const [pushData, setPushData] = useState({
    segment: [], // 선택된 세그먼트
    selectedUserIds: null,
    type: undefined, // 푸시 타입 (Integer)
    title: '',
    description: '',
    url: '',
    image: null, // 이미지 파일
    reservationTime: null, // 예약 시간
  })
  const [isReservation, setIsReservation] = useState(false)

  // 푸시 발송 파라미터 검증
  const validatePushParams = (params) => {
    const errors = []

    if (!params.userSegment) {
      errors.push('발송 대상을 선택해주세요.')
    }
    if (!params.pushType) {
      errors.push('푸시 타입을 선택해주세요.')
    }
    if (!params.title?.trim()) {
      errors.push('제목을 입력해주세요.')
    }
    if (!params.body?.trim()) {
      errors.push('내용을 입력해주세요.')
    }
    if (
      params.userSegment?.includes('SELECTED_USERS') &&
      (!params.selectedUserIds || params.selectedUserIds.length === 0)
    ) {
      errors.push('발송할 회원을 선택해주세요.')
    }

    if (isReservation && !params.reservationTime) {
      errors.push('예약 발송 시간을 선택해주세요.')
    }

    if (errors.length > 0) {
      alert(errors.join('\n'))
    }
  }

  // 푸시 발송 파라미터 생성
  const createPushParams = async () => {
    let imageUrl = null
    if (pushData.image) {
      // 템플릿에서 불러온 이미지인지 확인 (이미 완전한 URL인 경우)
      if (
        typeof pushData.image === 'string' &&
        pushData.image.startsWith('http')
      ) {
        imageUrl = pushData.image
        console.log('템플릿 불러온 url', imageUrl)
      } else {
        // 새로 업로드하는 이미지인 경우
        const s3Path = await s3Upload()
        if (!s3Path) {
          throw new Error('이미지 업로드에 실패했습니다.')
        }
        imageUrl = `${process.env.REACT_APP_S3_HOST}/${s3Path}`
        console.log('새로 업로드한 url', imageUrl)
      }
    }

    const params = {
      userSegment: pushData.segment,
      selectedUserIds: pushData.segment?.includes('SELECTED_USERS')
        ? pushData.selectedUserIds
        : null,
      pushType: pushData.type,
      title: pushData.title,
      body: pushData.description,
      url: pushData.url || null,
      imageUrl,
      reservationTime:
        isReservation && pushData.reservationTime
          ? pushData.reservationTime.format('YYYY-MM-DD HH:mm:ss')
          : dayjs().format('YYYY-MM-DD HH:mm:ss'),
    }

    validatePushParams(params)
    return params
  }

  // 상태 초기화
  const resetPushState = () => {
    setSelectedRowKeys([])
    setPushData({
      segment: null,
      selectedUserIds: null,
      type: undefined,
      title: '',
      description: '',
      url: '',
      image: null,
    })
  }

  const handleImageChange = (info) => {
    setPushData((prev) => ({
      ...prev,
      image: info.fileList.length > 0 ? info.fileList[0] : null,
    }))
  }

  const isFormValid = () => {
    if (!pushData.segment) {
      return false
    }
    if (
      pushData.segment?.includes('SELECTED_USERS') &&
      selectedRowKeys.length === 0
    ) {
      return false
    }
    if (isReservation && !pushData.reservationTime) {
      return false
    }
    return (
      pushData.type &&
      pushData.title.trim() !== '' &&
      pushData.description.trim() !== ''
    )
  }

  const s3Upload = async () => {
    try {
      const now = new Date()
      const monthFolder = `${now.getFullYear()}-${String(
        now.getMonth() + 1,
      ).padStart(2, '0')}`
      const timestamp = Date.now()
      const random = Math.random().toString(36).substring(2, 8)

      // 확장자를 png로 고정
      const s3Path = `push/salus/${monthFolder}/${timestamp}-${random}.png`
      console.log('s3Path', s3Path)
      let params = {
        Bucket: process.env.REACT_APP_S3_BUCKETNAME,
        Key: s3Path,
        Body: pushData.image.originFileObj,
      }
      let res = await salusS3.putObject(params).promise()

      if (res.$response.httpResponse.statusCode === 200) {
        return s3Path
      }
      return null
    } catch (error) {
      console.log(error)
      return null
    }
  }

  const handleSendPush = async () => {
    try {
      setIsLoading(true)
      // console.log('푸시 발송 시작')

      const params = await createPushParams()
      console.log('params', params)
      const res = await pushApi.sendAppPushToUser(params)
      // console.log('res', res)

      if (res.status === 200) {
        // console.log('푸시 발송 응답:', res.data)
        alert('푸시 발송에 성공했습니다.')
        resetPushState()
      }
    } catch (error) {
      console.error('푸시 발송 실패:', error)
      alert(error.message || '푸시 발송에 실패했습니다.')
    } finally {
      setIsLoading(false)
      setSearchOptions((prev) => ({
        ...prev,
        searchValue: null,
      }))
    }
  }

  const searchTypeItems = [
    { searchType: 'total', searchText: '전체검색' },
    { searchType: 'id', searchText: '아이디' },
    { searchType: 'phone', searchText: '연락처' },
  ]

  const dateTypeItems = [
    { label: '전체', value: 'total' },
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
  ]

  const columns = [
    {
      title: '회원번호',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '이름',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '생일',
      dataIndex: 'birthday',
      key: 'birthday',
      render: (value) => (value ? dayjs(value).format('YYYY.MM.DD') : '-'),
    },
    {
      title: '연락처',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '광고 수신 허용 여부',
      dataIndex: 'ad_alert',
      key: 'ad_alert',
      render: (value) => (value === true ? '허용' : '거절'),
    },
    {
      title: '가입일',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => (value ? dayjs(value).format('YYYY.MM.DD') : '-'),
    },
  ]

  // 회원 목록 조회
  useEffect(() => {
    if (pushData.segment?.includes('SELECTED_USERS')) {
      getReadMemberList('initial')
    }
  }, [pushData.segment])
  useEffect(() => {
    if (pushData.segment?.includes('SELECTED_USERS')) {
      getReadMemberList()
    }
  }, [offset, pageSize])

  const getReadMemberList = async (type = '') => {
    setIsLoading(true)
    let productType = null
    let categoryId = null
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: 'total',
          searchValue: null,
          startDate: null,
          endDate: null,
          orderType: 'created_at',
          orderBy: 'desc',
          signupReferralCode: null,
          productType: productType,
          categoryId: categoryId,
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format('YYYY-MM-DD')
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format('YYYY-MM-DD')
            : null,
          orderType: 'created_at',
          orderBy: 'desc',
          signupReferralCode: searchOptions.signupReferralCode,
          productType: productType,
          categoryId: categoryId,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format('YYYY-MM-DD')
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format('YYYY-MM-DD')
            : null,
          orderType: 'created_at',
          orderBy: 'desc',
          signupReferralCode: searchOptions.signupReferralCode,
          productType: productType,
          categoryId: categoryId,
        }
      }
      // console.log('param', param)
      const res = await customerApi.readCustomerList(param, user.id)
      if (res.data.code === 200) {
        setCustomers(
          CustomerAPIResponseMapper.getUserList(res.data.result.userList),
        )
        setTotalSize(res.data.result.totalCnt)

        // initial일 때만 전체 회원 수 저장
        if (type === 'initial') {
          setTotalCustomerCount((prev) => ({
            ...prev,
            all: res.data.result.totalCnt,
          }))
        }

        // 현재 페이지 회원 수 업데이트
        setTotalCustomerCount((prev) => ({
          ...prev,
          currentPageCount: res.data.result.userList.length,
        }))
      } else {
        alert(
          '회원 목록을 조회해오지 못하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      setCustomers([])
      setTotalSize(0)
      setTotalCustomerCount((prev) => ({
        ...prev,
        currentPageCount: 0,
      }))
      console.log('getReadMemberList read error', error)
    }
  }

  const handleDateTypeChange = (e) => {
    const value = e.target.value
    switch (value) {
      case 'total':
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: null,
          endDate: null,
        })
        break
      case 'today':
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: dayjs().subtract(7, 'days').startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1month':
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: dayjs().subtract(1, 'months').startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '3month':
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: dayjs().subtract(3, 'months').startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
    }
  }

  const handleSearch = () => {
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    getReadMemberList('search')
  }

  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: 'total',
      searchValue: null,
      dateType: 'total',
      startDate: null,
      endDate: null,
    })
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    getReadMemberList('initial')
  }

  const handleChangePagination = (pageNumber, pageSize) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
    setPageSize(pageSize)
  }

  // 회원 세그먼트 옵션
  const segmentOptions = Object.entries(UserSegment).map(([key, value]) => ({
    label: value,
    value: key,
  }))

  // 세그먼트 변경 핸들러도 수정
  const handleSegmentChange = (value) => {
    //리브레 현재 연동 중, 현재 연동 안 함 목록 체크
    let v = value
    // console.log('v', v)
    if (
      v.includes('IS_LIBRE_CONNECTED') &&
      v.includes('IS_LIBRE_NOT_CONNECTED')
    ) {
      // 마지막 선택만 남기고 반대 조건 제거
      v = v.filter(
        (item) =>
          item === value[value.length - 1] ||
          (item !== 'IS_LIBRE_CONNECTED' && item !== 'IS_LIBRE_NOT_CONNECTED'),
      )
    }

    setPushData((prev) => ({
      ...prev,
      segment: v,
    }))
    setSelectedRowKeys([])
    if (!value.includes('SELECTED_USERS')) {
      setCustomers([])
      setTotalSize(0)
      setTotalCustomerCount((prev) => ({
        ...prev,
        currentPageCount: 0,
      }))
    }
  }

  // 템플릿 변경
  const handleTemplateSelect = (template) => {
    setPushData((prev) => ({
      ...prev,
      title: template.pushTitle,
      description: template.pushBody,
      url: template.pushUrl ? template.pushUrl : null,
      image: template.pushImageUrl ? template.pushImageUrl : null,
    }))
    setIsTemplateModalOpen(false)
  }

  return (
    <>
      <Spin spinning={isLoading}>
        <div style={{ width: '100%', paddingBottom: '8rem' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              background: '#fff',
            }}
          >
            <ContentHeader title="앱푸시 발송" />
            <Tooltip title="선택한 회원들에게 앱 푸시 알림을 발송할 수 있습니다. 광고 수신 동의 회원을 일괄 선택하거나, 개별 회원을 선택하여 발송할 수 있습니다. 해당 푸시는 알림 히스토리에 남습니다.">
              <ExclamationCircleOutlined
                style={{
                  color: 'red',
                  fontSize: '20px',
                  cursor: 'help',
                }}
              />
            </Tooltip>
          </div>

          {/* 회원 선택 */}
          <Card
            title={
              <div className={styles['product-register-form-title']}>
                <UserOutlined />
                <span style={{ marginLeft: '10px' }}>회원 선택</span>
                {pushData.segment?.includes('SELECTED_USERS') && (
                  <>
                    <span style={{ marginLeft: '10px', color: '#1890ff' }}>
                      {(pushData.selectedUserIds?.length || 0).toLocaleString()}
                      명 선택됨
                    </span>
                    <span>
                      {' '}
                      / 총 {totalCustomerCount.all.toLocaleString()}명
                    </span>
                    {searchOptions.searchType !== 'total' && (
                      <span style={{ marginLeft: '10px', color: '#666' }}>
                        (현재 페이지 {totalCustomerCount.currentPageCount}명)
                      </span>
                    )}
                    <Button
                      onClick={() => {
                        setSelectedRowKeys([])
                        setPushData((prev) => ({
                          ...prev,
                          selectedUserIds: [],
                        }))
                      }}
                      style={{ marginLeft: '10px' }}
                    >
                      회원 선택 초기화
                    </Button>
                  </>
                )}
              </div>
            }
            style={{ marginBottom: 20 }}
          >
            <Form.Item
              label={
                <span>
                  발송 대상
                  <Tooltip
                    title="여러 조건을 선택하면 모든 조건을 동시에 만족하는 회원에게만 발송됩니다.
                  예시: '광고 허락' + '60대 이상' → 두 조건을 모두 만족하는 회원만 발송"
                  >
                    <ExclamationCircleOutlined
                      style={{ color: 'red', marginLeft: 6, cursor: 'help' }}
                    />
                  </Tooltip>
                </span>
              }
              required
              style={{ marginBottom: 16 }}
              labelCol={{ flex: '0 0 100px' }}
              wrapperCol={{ flex: '1 1 auto' }}
              labelAlign="left"
            >
              <Select
                mode="multiple"
                style={{ width: '300px' }}
                placeholder="발송 대상을 선택하세요"
                options={segmentOptions}
                value={pushData.segment}
                onChange={handleSegmentChange}
              />
            </Form.Item>

            {pushData.segment?.includes('SELECTED_USERS') && (
              <>
                <div className={styles['product-search-box-wrap']}>
                  {/* 기존 검색 폼 */}
                  <Form.Item
                    className={styles['center-label']}
                    label="검색"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 21 }}
                  >
                    <Select
                      value={searchOptions.searchType}
                      onChange={(value) =>
                        setSearchOptions({
                          ...searchOptions,
                          searchType: value,
                        })
                      }
                      style={{ width: 200, textAlign: 'left' }}
                    >
                      {searchTypeItems.map((item, idx) => (
                        <Select.Option
                          key={`search_type_${idx}`}
                          value={item.searchType}
                        >
                          {item.searchText}
                        </Select.Option>
                      ))}
                    </Select>
                    <Input
                      className={styles['inquiry-search-input-wrap']}
                      placeholder="검색어를 입력하세요."
                      name="searchValue"
                      value={searchOptions.searchValue}
                      onChange={(e) =>
                        setSearchOptions({
                          ...searchOptions,
                          [e.target.name]: e.target.value,
                        })
                      }
                      onPressEnter={handleSearch}
                    />
                  </Form.Item>
                  <Divider
                    className={styles['product-register-form-input-divider']}
                  />
                  <Form.Item
                    className={styles['center-label']}
                    label="가입일"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 21 }}
                  >
                    <ConfigProvider theme={CustomDateButtonRadioTheme}>
                      <Row align={'middle'} style={{ gap: '5px' }}>
                        <Radio.Group
                          className={styles['options-list']}
                          options={dateTypeItems}
                          onChange={handleDateTypeChange}
                          value={searchOptions.dateType}
                          optionType="button"
                        />
                        <DatePicker
                          className={styles['order-search-date-wrap']}
                          format="YYYY/MM/DD"
                          allowClear={false}
                          value={searchOptions.startDate}
                          disabled={searchOptions.dateType === 'total'}
                          onChange={(value) => {
                            setSearchOptions({
                              ...searchOptions,
                              dateType: null,
                              startDate: value,
                            })
                          }}
                        />
                        ~
                        <DatePicker
                          className={styles['order-search-date-wrap']}
                          format="YYYY/MM/DD"
                          allowClear={false}
                          value={searchOptions.endDate}
                          disabled={searchOptions.dateType === 'total'}
                          onChange={(value) => {
                            setSearchOptions({
                              ...searchOptions,
                              dateType: null,
                              endDate: value,
                            })
                          }}
                        />
                      </Row>
                    </ConfigProvider>
                  </Form.Item>
                  <Row
                    className={styles['review-search-button-wrap']}
                    justify="center"
                    style={{ display: 'flex', gap: '10px' }}
                  >
                    <Button
                      className={`${styles['review-search-button']} ${styles.search}`}
                      onClick={handleSearch}
                    >
                      검색
                    </Button>
                    <Button
                      className={`${styles['review-search-button']} ${styles.initial}`}
                      onClick={handleInitialBtnClick}
                    >
                      초기화
                    </Button>
                  </Row>
                </div>
                <Table
                  rowSelection={{
                    selectedRowKeys,
                    onChange: (selectedRowKeys) => {
                      // 현재 페이지에서 선택된 행들의 ID를 Set으로 관리
                      const currentPageIds = new Set(
                        customers.map((customer) => customer.id),
                      )
                      // 이전 selectedUserIds 중에서 현재 페이지의 항목이 아닌 것들은 유지
                      const previousSelectedIds = (
                        pushData.selectedUserIds || []
                      ).filter((id) => !currentPageIds.has(id))
                      // 현재 페이지의 새로운 선택을 반영
                      const newSelectedIds = [
                        ...previousSelectedIds,
                        ...selectedRowKeys,
                      ]
                      setSelectedRowKeys(selectedRowKeys)
                      setPushData((prev) => ({
                        ...prev,
                        selectedUserIds: newSelectedIds,
                      }))
                    },
                  }}
                  columns={columns}
                  dataSource={customers}
                  rowKey="id"
                  pagination={{
                    current: currentPageNumber,
                    pageSize: pageSize,
                    total: totalSize,
                    onChange: handleChangePagination,
                    showSizeChanger: true,
                  }}
                  size="middle"
                  scroll={{ x: 'max-content' }}
                  loading={isLoading}
                  style={{ marginTop: 20 }}
                />
              </>
            )}
          </Card>

          {/* 푸시 타입 */}
          <Card
            title={
              <>
                <TagsOutlined style={{ marginRight: 8 }} />
                푸시 타입 <span style={{ color: 'red' }}>*</span>
              </>
            }
            style={{ marginBottom: 20 }}
          >
            <Select
              style={{
                width: '33%',
                minWidth: 200,
              }}
              placeholder="푸시 타입을 선택하세요"
              options={pushTypeOptions}
              value={pushData.type}
              onChange={(value) =>
                setPushData((prev) => ({ ...prev, type: value }))
              }
            />
          </Card>

          {/* 푸시 내용 */}
          <Card
            title={
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <div>
                    <InfoCircleOutlined style={{ marginRight: 8 }} />
                    푸시 내용 <span style={{ color: 'red' }}>*</span>
                  </div>
                  <Button
                    type="primary"
                    onClick={() => {
                      setIsTemplateModalOpen(true)
                    }}
                  >
                    템플릿 불러오기
                  </Button>
                </div>
              </>
            }
            style={{ marginBottom: 20 }}
          >
            <Form.Item
              label="제목"
              required
              style={{ marginBottom: 16 }}
              labelCol={{ flex: '0 0 100px' }}
              wrapperCol={{ flex: '1 1 auto' }}
              labelAlign="left"
            >
              <Input
                placeholder="푸시 알림 제목을 입력하세요"
                value={pushData.title}
                onChange={(e) =>
                  setPushData((prev) => ({ ...prev, title: e.target.value }))
                }
                maxLength={50}
                style={{ width: '50%' }}
              />
            </Form.Item>

            <Form.Item
              label="내용"
              required
              style={{ marginBottom: 16 }}
              labelCol={{ flex: '0 0 100px' }}
              wrapperCol={{ flex: '1 1 auto' }}
              labelAlign="left"
            >
              <Input.TextArea
                placeholder="푸시 알림 내용을 입력하세요"
                value={pushData.description}
                onChange={(e) =>
                  setPushData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                maxLength={200}
                style={{ width: '50%' }}
                rows={4}
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  연결 링크
                  <Tooltip
                    title="푸시 클릭 시 연결될 URL을 입력하세요. 푸시 클릭 시 해당 URL로 이동합니다. 경로가 올바르지 않을 경우 이동하지 않습니다.
              URL 발송 전 꼭 개발팀에 확인해주세요!"
                  >
                    <ExclamationCircleOutlined
                      style={{ color: 'red', marginLeft: 6, cursor: 'help' }}
                    />
                  </Tooltip>
                </span>
              }
              style={{ marginBottom: 16 }}
              labelCol={{ flex: '0 0 100px' }}
              wrapperCol={{ flex: '1 1 auto' }}
              labelAlign="left"
            >
              <Input
                prefix={<LinkOutlined />}
                placeholder="연결될 URL을 입력하세요 (선택사항)"
                value={pushData.url}
                onChange={(e) =>
                  setPushData((prev) => ({ ...prev, url: e.target.value }))
                }
                style={{ width: '50%' }}
              />
            </Form.Item>

            <Form.Item
              label="이미지"
              style={{ marginBottom: 0 }}
              labelCol={{ flex: '0 0 100px' }}
              wrapperCol={{ flex: '1 1 auto' }}
              labelAlign="left"
            >
              <div style={{ width: '25vw', minWidth: 200 }}>
                <Upload
                  name="image"
                  maxCount={1}
                  listType="picture"
                  accept="image/png"
                  beforeUpload={(file) => {
                    const isPNG = file.type === 'image/png'
                    if (!isPNG) {
                      alert('PNG 파일만 업로드 가능합니다!')
                    }
                    return false
                  }}
                  onChange={handleImageChange}
                  fileList={
                    pushData.image
                      ? typeof pushData.image === 'string'
                        ? [
                            {
                              uid: '-1',
                              name: 'template-image.png',
                              status: 'done',
                              url: pushData.image,
                            },
                          ]
                        : [pushData.image]
                      : []
                  }
                  style={{
                    width: '100%',
                    minWidth: 200,
                  }}
                >
                  <Button
                    style={{
                      width: '200px',
                      height: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <UploadOutlined style={{ fontSize: '24px' }} />
                    <span>이미지 선택&nbsp;</span>
                    <span style={{ fontSize: '12px', color: '#666' }}>
                      (png 형식 필수)
                    </span>
                    <span style={{ fontSize: '8px', color: '#666' }}>
                      png형식이 가장 덜 깨집니다.
                    </span>
                  </Button>
                </Upload>
              </div>
            </Form.Item>

            <Form.Item
              label="예약 발송"
              style={{ marginTop: 16, marginBottom: 0 }}
              labelCol={{ flex: '0 0 100px' }}
              wrapperCol={{ flex: '1 1 auto' }}
              labelAlign="left"
            >
              <Row align="middle" gutter={8}>
                <Col>
                  <Checkbox
                    checked={isReservation}
                    onChange={(e) => {
                      setIsReservation(e.target.checked)
                      if (!e.target.checked) {
                        setPushData((prev) => ({
                          ...prev,
                          reservationTime: null,
                        }))
                      }
                    }}
                  >
                    예약 발송 사용
                  </Checkbox>
                </Col>
                {isReservation && (
                  <DatePicker
                    showTime
                    value={pushData.reservationTime}
                    onChange={(value) => {
                      setPushData((prev) => ({
                        ...prev,
                        reservationTime: value,
                      }))
                    }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder="예약 발송 시간 선택"
                    disabledDate={(current) =>
                      current && current < dayjs().startOf('minute')
                    }
                  />
                )}
              </Row>
            </Form.Item>
          </Card>

          {/* 발송 버튼 */}
          <div className={`${styles['product-register-fixed-footer']}`}>
            <Button
              type="primary"
              size="large"
              loading={isLoading}
              disabled={!isFormValid()}
              onClick={handleSendPush}
              className={`${styles['product-register-button']} ${styles.save}`}
            >
              발송하기
            </Button>
          </div>
        </div>
      </Spin>

      {isTemplateModalOpen && (
        <AppPushTemplatesModal
          open={isTemplateModalOpen}
          onCancel={() => setIsTemplateModalOpen(false)}
          onSelect={handleTemplateSelect}
          selectedTemplate={pushData}
        />
      )}
    </>
  )
}

export default AppPushSendPage
